import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router-dom';

import '../styles/Servicehero.css';

import img1 from '../assets/electricaldesign.jpg';
import img2 from '../assets/equipmentrental.jpg';
import img3 from '../assets/oilfiltration.avif';
import img4 from '../assets/manpower.jpg';
import img6 from '../assets/maintananceservice.jpg';
import img7 from '../assets/testing.jpg';

const slides = [
  {
    img: img1,
    heading: "Engineering Design",
    description: "We deliver innovative engineering solutions.",
    route: "service1",
  },
  {
    img: img7,
    heading: "Testing & Commissioning",
    description: "Thorough testing before going live.",
    route: "service2",
  },
  {
    img: img2,
    heading: "Equipment Rental",
    description: "High-performance tools and machinery on demand.",
    route: "service3",
  },
  {
    img: img4,
    heading: "Skilled Manpower",
    description: "Certified professionals for every industrial need.",
    route: "service4",
  },
  {
    img: img3,
    heading: "Transformer Oil Filtration",
    description: "Maintaining transformer efficiency and life span.",
    route: "service5",
  },
  {
    img: img6,
    heading: "Maintenance Services",
    description: "Reliable servicing for uninterrupted operations.",
    route: "service6",
  },
];

const Servicehero = () => {
  return (
    <div className="servicehero-container">
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        coverflowEffect={{
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={{ clickable: true }}
        modules={[EffectCoverflow, Pagination, Autoplay]}
        className="servicehero-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index} className="coverflow-slide">
            <Link to={`/services/${slide.route}`} style={{ display: 'block', width: '100%', height: '100%' }}>
              <img src={slide.img} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className="slide-overlay">
                <h1>{slide.heading}</h1>
                <p>{slide.description}</p>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Servicehero;
